import { useEffect, useRef, useState } from 'react';
import { LocalStorage } from 'src/utils/LocalStorage';
import { Installments } from '../OrderSummary/types';
import { CheckoutInfoFields } from './CheckoutInfoPage/CheckoutInfoPage';

export const CHECKOUT_LOCAL_STORAGE_KEY = 'checkout-user';
const CHECKOUT_PLAN_LOCAL_STORAGE_KEY = 'checkout-plan';

export const useCheckoutInternal = () => {
  const [hasApiError, setHasApiError] = useState(false);

  const [selectedPurchaseType, setSelectedPurchaseType] = useState<Installments>(() => {
    const storedPlan = LocalStorage.tryGetItem(CHECKOUT_PLAN_LOCAL_STORAGE_KEY);
    if (!storedPlan) return Installments.P;
    return storedPlan as Installments;
  });
  const [emailAddress, setEmailAddress] = useState('');
  const [userInfo, setUserInfo] = useState<CheckoutInfoFields | null>(() => {
    return LocalStorage.tryGetJSONItem(CHECKOUT_LOCAL_STORAGE_KEY) as CheckoutInfoFields;
  });
  const [isUserInfoValid, setUserInfoValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const phoneNumber = '+18442911950';
  const continueButtonRef = useRef<HTMLButtonElement | null>(null);

  useEffect(() => {
    LocalStorage.trySetItem(CHECKOUT_PLAN_LOCAL_STORAGE_KEY, selectedPurchaseType);
  }, [selectedPurchaseType]);

  return {
    emailAddress,
    setEmailAddress,
    userInfo,
    setUserInfo,
    isUserInfoValid,
    setUserInfoValid,
    phoneNumber,
    isLoading,
    setIsLoading,
    selectedPurchaseType,
    setSelectedPurchaseType,
    hasApiError,
    setHasApiError,
    continueButtonRef,
  };
};

export type CheckoutContext = ReturnType<typeof useCheckoutInternal>;
